module.exports = __webpack_public_path__ + "static/citymed-c5e615db5bda9d86c7ccce2f7404e565.png";